import { Link } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import "./ManagePharmacyBranch.css";
import useAuthCheck from "../../useAuthCheck";
import { useEffect, useState } from "react";
import api from "../../api";

const ENV = process.env.REACT_APP_ENV || "production";
const IS_DESKTOP = ENV === "desktop";

const getNetworkErrorMessage = (err) => {
  const isNetworkError = (
    !navigator.onLine ||
    err.code === "ERR_NETWORK" ||
    err.code === "ERR_INTERNET_DISCONNECTED" ||
    err.code === "ERR_NAME_NOT_RESOLVED" ||
    err.code === "ERR_CONNECTION_REFUSED" ||
    err.code === "ERR_CONNECTION_TIMED_OUT" ||
    err.message === "Network Error" ||
    err.message?.includes("ERR_INTERNET_DISCONNECTED") ||
    err.message?.includes("net::")
  );
  if (isNetworkError) {
    if (IS_DESKTOP) return "🔧 Cannot connect to local server. Please restart the MyApoti desktop app.";
    return "📡 No internet connection. Please check your network and try again.";
  }
  return null;
};

const ManagePharmacyBranch = () => {
  useAuthCheck();

  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [networkError, setNetworkError] = useState("");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchVerificationStatus = async () => {
      setIsLoading(true);
      try {
        await api.get("/auth/me/");
      } catch (error) {
        const netMsg = getNetworkErrorMessage(error);
        if (netMsg) setNetworkError(netMsg);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVerificationStatus();
  }, []);

  if (isLoading) {
    return (
      <div className="dashboard-container">
        {!isMobile && <Sidebar />}
        <div className="main-dashboard">
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  if (networkError) {
    return (
      <div className="dashboard-container">
        {!isMobile && <Sidebar />}
        <div className="main-dashboard">
          <div className="card">
            <div style={{ textAlign: "center", padding: "2rem" }}>
              <p style={{ fontSize: "2.5rem", marginBottom: "0.5rem" }}>{IS_DESKTOP ? "🔧" : "📡"}</p>
              <h3 style={{ color: "#dc3545", marginBottom: "0.5rem" }}>Connection Error</h3>
              <p style={{ color: "#555", marginBottom: "1.5rem" }}>{networkError}</p>
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: "0.6rem 1.5rem", background: "#dc3545", color: "white",
                  border: "none", borderRadius: "6px", cursor: "pointer",
                  fontWeight: "600", fontSize: "0.95rem",
                }}
              >
                🔄 Retry
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      {!isMobile && <Sidebar />}
      <div className="main-dashboard">
        <div className="card">
          <h1 className="title">🏪 Pharmacy Branch Management</h1>
          <div className="button-grid">
            <Link to="/CreatePharmacyBranch" className="btn">➕ Create New Branch</Link>
            <Link to="/PharmacyBranches" className="btn">📋 View All Branches</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagePharmacyBranch;